import React, { useEffect, useState } from 'react'
import { IoIosArrowBack } from 'react-icons/io'
import { useNavigate, useParams } from 'react-router-dom'
import api from '../../../api/api'
import { useAppDispatch } from '../../../store/store'
import { setLoading } from '../../../store/slice/utilSlice'

type Props = {}

const AttendanceView = (props: Props) => {
    const { type,  id, attendanceId } = useParams()
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const [attendanceData, setAttendanceData] = useState({
        branch_name: "",
        class_pic: "",
        coaches: [],
        course_date: "",
        course_name: "",
        day: "",
        description: "",
        end_time: "",
        start_time: "",
        id: "",
    })
    const [studentData, setStudentData] = useState({
        name: ""
    })

    useEffect(() => {
        getAttendanceDetail()
    }, [])

    function getAttendanceDetail() {
        
        dispatch(setLoading(true))
        api.get(`${process.env.REACT_APP_API_BASE_URL}/attendance/${attendanceId}`)
        .then( res => {
            console.log("attendance res", res)
            setAttendanceData(res.data.data)
            getStudentDetail()
        }).catch( err => {
            console.log("err", err)
        }).finally(()=>{
            dispatch(setLoading(false))
        })
    }
    

    
    const getStudentDetail = async () => {
        dispatch(setLoading(true))
        api.get(`${process.env.REACT_APP_API_BASE_URL}/student/${id}`).then( res => {
            console.log("res studentDetails", res.data.data)
            setStudentData({
                name: res.data.data.name,
            })
        }).catch( err => {
            dispatch(setLoading(false))
            console.log("err", err)
        })
    }


    const navigateBack = () => {
        navigate(`/children/edit/${id}`)
    }


    return (
        <div className="pb-24 px-3">
            <div className='mb-2 grid grid-cols-3'>
                <div className='col-span-1'><IoIosArrowBack size={28} color='#000' onClick={()=>navigateBack()}/></div>
                <div className='col-span-1 text-lg text-center font-medium'>Attendance</div>
                <div className='col-span-1'></div>
            </div>

            <div className='my-2 mt-4 grid grid-cols-2 text-base'>
                <div>
                    <span className='font-semibold'>Date:</span> {attendanceData.course_date}
                </div>
                <div>
                    <span className='font-semibold'>Time:</span> {attendanceData.start_time} - {attendanceData.end_time}
                </div>
            </div>
            
            <div className='my-2 grid grid-cols-2 text-base'>
                <div className='col-span-1'>
                    <span className='font-semibold'>Course Name:</span> {attendanceData.course_name}
                </div>
                <div className='col-span-1'>
                    <span className='font-semibold'>Branch Name:</span> {attendanceData.branch_name}
                </div>
            </div>
            
            <div className='mt-4 justify-items-center'>
                <img src={attendanceData.class_pic} alt="Captured" className="rounded-md  max-h-72" />
            </div>

            <div className='mt-4'>
                <div className='font-semibold text-base'>Today's Focus:</div>
                <textarea rows={5} className='w-full bg-slate-200 rounded px-2 py-1 mt-2' value={attendanceData.description} disabled/>
            </div>

            
            <div className='mt-4'>
                <div className='font-semibold text-base'>Coaches</div>
                <div className="table-responsive">
                    <table className="">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th className='text-center'>Attended</th>
                            </tr>
                        </thead>
                        <tbody>
                        {attendanceData.coaches && attendanceData.coaches.map((item:any, index:number) => {
                            return (
                                <tr key={index}>
                                    <td style={{width: "65%"}}>
                                        <div>{item.name}</div>
                                    </td>
                                    <td  className='text-center'>
                                        <div>
                                            <label className="inline-flex cursor-pointer">
                                                <input type="checkbox" checked={true} className="form-checkbox" />
                                            </label>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className='mt-4'>
                <div className='font-semibold text-base'>Student</div>
                <div className="table-responsive">
                    <table className="">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th className='text-center'>Attended</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{width: "65%"}}>
                                    <div>{studentData.name}</div>
                                </td>
                                <td className='text-center'>
                                    <div>
                                        <label className="inline-flex cursor-pointer">
                                            <input type="checkbox" checked={true} className="form-checkbox" />
                                        </label>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>


        </div>
    )
}

export default AttendanceView